import React from "react"
import { PrivatePersonForm } from "./PrivatePersonForm"
import { BillReceiversType, BillTypeMap } from "../../billReceiversTypes"
import { PublicInstitutionForm } from "./PublicInstitutionForm"
import { PrivateCompanyForm } from "./PrivateCompanyForm"
import { selectEffectiveUserType } from "../../../../../../context/contextSelectors"
import { useAppSelector } from "../../../../../../store/storeHooks"
import { UserType } from "../../../../../../login/loginTypes"

const componentsMap: BillTypeMap<React.ComponentType<any>> = {
    [BillReceiversType.PRIVATE_PERSON]: PrivatePersonForm,
    [BillReceiversType.PUBLIC_INSTITUTION]: PublicInstitutionForm,
    [BillReceiversType.PRIVATE_COMPANY]: PrivateCompanyForm,
}

export const DynamicForm = ({ componentType }: { componentType: BillReceiversType }) => {
    const userType = useAppSelector(selectEffectiveUserType)
    const Component = componentsMap[componentType]
    return Component ? <Component isMerchantAdmin={userType === UserType.MERCHANT} /> : null
}
